const loaded = { currentIds: [] };

export function initTiktokPixel(platformId, customId) {
  const ids = [platformId, customId].filter(Boolean);
  if (!ids.length) return;
  if (loaded.currentIds.join() === ids.join()) return;
  loaded.currentIds = ids;

  const existing = document.getElementById('tiktok-pixel');
  if (existing) existing.remove();

  window.ttq = window.ttq || [];
  window.ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie',
  ];
  window.ttq.setAndDefer = function (t, e) {
    t[e] = function () {
      t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };
  for (let i = 0; i < window.ttq.methods.length; i += 1) {
    window.ttq.setAndDefer(window.ttq, window.ttq.methods[i]);
  }
  window.ttq.instance = function (t) {
    const e = window.ttq;
    if (e._i[t]) return e._i[t];
    const n = [];
    n._i = {};
    n._i[t] = { _e: [], _u: t };
    n.setAndDefer = function (t2, e2) {
      t2[e2] = function () {
        t2.push([e2].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (let i = 0; i < e.methods.length; i += 1) {
      n.setAndDefer(n, e.methods[i]);
    }
    return n;
  };
  window.ttq.load = function (t, e) {
    const n = 'https://analytics.tiktok.com/i18n/pixel/events.js';
    window.ttq._i = window.ttq._i || {};
    window.ttq._i[t] = { _u: n, _t: t };
    window.ttq._t = window.ttq._t || {};
    window.ttq._t[t] = +new Date();
    window.ttq._o = window.ttq._o || {};
    window.ttq._o[t] = e || {};
    const r = document.createElement('script');
    r.async = true;
    r.src = n + '?sdkid=' + t + '&lib=ttq';
    r.id = 'tiktok-pixel';
    document.head.appendChild(r);
  };
  window.ttq.page = function () {
    window.ttq.push(['page']);
  };
  window.ttq._i = window.ttq._i || {};

  ids.forEach((id) => {
    window.ttq.load(id);
  });
}

export function trackTiktokPageView() {
  const ids = loaded.currentIds;
  if (!window.ttq || !ids.length) return;
  window.ttq.page();
}
